import React from 'react';

const FieldSales = () => {
  const styles = {
    badgeRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10,
      alignItems: 'center',
      marginTop: 6,
      marginBottom: 16,
      padding: '10px 12px',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      fontSize: 13.5,
      color: '#111827',
      lineHeight: 1.4,
    },
    badgeDot: {
      color: '#9ca3af',
    },
    p: {
      fontSize: 14.5,
      lineHeight: 1.75,
      margin: '10px 0',
      color: '#111827',
    },
    h2: {
      fontSize: 18,
      margin: '26px 0 10px',
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },
    h3: {
      margin: '18px 0 8px',
      fontSize: 15,
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },
    ul: {
      margin: '10px 0 10px 22px',
      fontSize: 14.5,
      lineHeight: 1.75,
      color: '#111827',
    },
    highlightBox: {
      marginTop: 18,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #dbeafe',
      background: '#eff6ff',
      lineHeight: 1.6,
    },
    highlightText: {
      margin: 0,
      fontSize: 14.5,
      color: '#111827',
    },
  };

  return (
    <div>
      {/* Role title */}
      <h2 style={styles.h2}>Field Sales Representative</h2>

      {/* Badges */}
      <div style={styles.badgeRow}>
        <span>
          📍 <strong>Chicago Area</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          💵 <strong>$20/hour</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🤝 <strong>Team-Based Role</strong>
        </span>
      </div>

      <p style={styles.p}>
        We’re a food-delivery startup dedicated to helping local restaurants grow through fair
        partnerships and practical, easy-to-use tools
      </p>

      <p style={styles.p}>
        We’re looking for a motivated, confident communicator to join our field sales team. You’ll
        visit restaurants, start friendly introduction conversations, and help restaurant owners
        understand who we are and why our platform matters.
      </p>

      <p style={styles.p}>
        This is a great opportunity for someone who enjoys talking to people, presenting ideas
        clearly, and working as part of a supportive team.
      </p>

      <h3 style={styles.h3}>What we’re looking for</h3>
      <ul style={styles.ul}>
        <li>Strong communication and presentation skills</li>
        <li>Positive, motivated, and reliable attitude</li>
        <li>Comfortable starting conversations with restaurant owners</li>
        <li>Team-player mindset</li>
      </ul>

      <h3 style={styles.h3}>What we offer</h3>
      <ul style={styles.ul}>
        <li>$20 per hour</li>
        <li>Part-time (Monday–Thursday)</li>
        <li>Supportive team environment</li>
        <li>Opportunity to grow with the company</li>
      </ul>

      <div style={styles.highlightBox}>
        <p style={styles.highlightText}>
          If you’re energetic, personable, and ready to be part of a startup journey,&nbsp;
          <strong>apply now!</strong>
        </p>
      </div>
      <div
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 14,
          border: '2px solid #FF6138',
          background: '#fff2ecff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: '#111827',
                letterSpacing: '-0.01em',
              }}
            >
              Apply by Email
            </div>
            <div style={{ marginTop: 6, fontSize: 13.5, color: '#374151', lineHeight: 1.6 }}>
              Email your <strong>CV/Resume</strong> and mention the <strong>Job Title</strong> in
              the subject line.
            </div>
          </div>

          <a
            href='mailto:jobs@singlecombo.com?subject=Application%20-%20Field%20Sales%20Representative%20(Chicago)'
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 12px',
              borderRadius: 12,
              border: '1px solid #dbeafe',
              background: '#eff6ff',
              color: '#111827',
              textDecoration: 'none',
              fontSize: 13.5,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
            aria-label='Email jobs@singlecombo.com'
          >
            ✉️ jobs@singlecombo.com
          </a>
        </div>

        <div
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gap: 8,
          }}
        >
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            <strong style={{ color: '#111827' }}>Subject:</strong> Application - Field Sales
            Representative (Chicago)
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
            <strong style={{ color: '#111827' }}>Include:</strong> Name • Phone • Area/Neighborhood
            • Availability (Mon–Thu) • Sales experience (if any)
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldSales;
